import { useContext } from "react"
import { AuthContext } from "../../contexts/AuthContext"
import { Link } from "react-router-dom";
import { ParameterContext } from "../../contexts/ParameterContext";

/* eslint-disable react/prop-types */
export default function Header(props) {
    const { user } = useContext(AuthContext);
    const { parameters} = useContext(ParameterContext)
    
    return (
        <header id="header" className="header fixed-top d-flex align-items-center">

            <div className="d-flex align-items-center justify-content-between">
                <Link to="/schadm" className="logo d-flex align-items-center">
                    {/*<img src="assets/img/logo.png" alt="" />*/}
                    <b>Прием I клас - {parameters.municipality.obshtina_name} </b>
              </Link>
              <i className="bi bi-list toggle-sidebar-btn" onClick={props.hsmenu}></i>
            </div>

            

            <nav className="header-nav ms-auto ">
                <ul className="d-flex align-items-center">

                    <li className="nav-item dropdown pe-3">

                        <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                            <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
                            <span className="d-none d-md-block dropdown-toggle ps-2">{user.role == 'Director' ? user.school.shortName : user.fullName} ( {user.role} )</span>
                            {/*<span className="d-none d-md-block dropdown-toggle ps-2">{user.fullName} ( {user.role} {user.role === 'Director'? - user.school.name : ' ' } )</span>*/}
                        </a>

                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                <h6>{user.fullName}</h6>
                                <span>{user.role}</span>
                            </li>

                            <li>
                                <hr className="dropdown-divider" />
                            </li>

                            <li>
                                <hr className="dropdown-divider" />
                            </li>

                            <li>
                                <hr className="dropdown-divider" />
                            </li>

              
                            <li>
                                <hr className="dropdown-divider" />
                            </li>

                            <li>
                                <Link className="dropdown-item d-flex align-items-center" to="logout">
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Изход</span>
                                </Link>
                            </li>

                        </ul>
                    </li>

                </ul>
            </nav>

        </header>
    )
}